var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prize",on:{"click":_vm.routeTo}},[_c('img',{attrs:{"src":_vm.advertisingInfo.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }